import React, { useState } from 'react';
import { ASPETTI, getAspetto, setAspetto } from '../aspetto';

// Selettore Aspetto (stile linee): spigoloso = angoli retti, morbido = arrotondato.
// Cambia solo raggi/bordi/ombre, nessun colore. Persistenza localStorage.
export default function AspettoPicker() {
  const [aspetto, setAspettoState] = useState(getAspetto());
  const choose = (id) => { setAspetto(id); setAspettoState(id); };

  return (
    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
      {ASPETTI.map((a) => (
        <button
          key={a.id}
          type="button"
          onClick={() => choose(a.id)}
          style={{
            cursor: 'pointer', background: 'var(--surface-2)', borderRadius: 12,
            padding: '8px 12px',
            border: aspetto === a.id ? '2px solid var(--accent)' : '1px solid var(--line)',
            display: 'flex', alignItems: 'center', gap: 9, minWidth: 118,
          }}
        >
          <span
            aria-hidden="true"
            style={{
              width: 26, height: 18, background: 'var(--accent)',
              borderRadius: a.id === 'morbido' ? 9 : 2, flex: '0 0 auto',
            }}
          />
          <span style={{ fontWeight: 700, fontSize: 13, color: aspetto === a.id ? 'var(--accent)' : 'var(--text)' }}>{a.label}</span>
        </button>
      ))}
    </div>
  );
}
